import { render, staticRenderFns } from "./VideoCallButton.vue?vue&type=template&id=0ddfbb22&scoped=true"
import script from "./VideoCallButton.vue?vue&type=script&lang=js"
export * from "./VideoCallButton.vue?vue&type=script&lang=js"
import style0 from "./VideoCallButton.vue?vue&type=style&index=0&id=0ddfbb22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddfbb22",
  null
  
)

export default component.exports